import * as React from 'react';
import { viewChart } from 'components/chart/chart';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { EventFunc } from 'types/types';
import {UIState} from "data/UIState";

import './MilestonesDashboard.pcss';



/**
 *
 *  DEPRECATED!!!!
 *
 */


@observer
export class MilestonesDashboard extends React.Component<{
  chartablePosts:any, 
  mini:boolean, 
  handleClickToRewardsPage:EventFunc, 
  handleClickToGoalsPage:EventFunc,
  pointsStatus:any, 
  icon?:string, 
  milestone?:any
  solution:any;
}> {

  @observable longTermGoal:any;
  @observable shortTermGoals:Array<any>;
  
  constructor(props){
    super(props); 

    let longTermGoal = null;
    const shortTermGoals:Array<any> = [];

    UIState.user.goals.forEach(goal=>{
        if(!goal.hasBeenAccomplished) {
          if(goal.type=='long') {
            longTermGoal = JSON.parse(JSON.stringify(goal));
          } else {
            shortTermGoals.push(JSON.parse(JSON.stringify(goal)));
          }
        }
      });

    this.longTermGoal = longTermGoal;
    this.shortTermGoals = shortTermGoals;
  }

  render() {
    const hasLongTermGoal = (null!==this.longTermGoal);
    const hasShortTermGoals  = this.shortTermGoals.length>0;
    const hasGoals = hasLongTermGoal || hasShortTermGoals;
    const howManyShortTermGoals = this.shortTermGoals.length;
    const howManyGoals = howManyShortTermGoals + (hasLongTermGoal?1:0);
    const widgetContainerWidth = ((2+this.props.chartablePosts.length)*125);
    let widgetContainerStyle = {
      width:widgetContainerWidth+'px'
    };


    return (
      <div className="milestonesDashboard">
        {/*<p>Hi {UIState.user.firstName}</p>*/}
        {UIState.settings.ENABLE_GOALS &&
          <h2>
            {hasGoals ?
              <span>
            Your current goal{howManyGoals > 1 ? 's: ' : ': '}
                <span>
              {this.longTermGoal && <span><span
                className="goal long">{this.longTermGoal.description}</span>{hasShortTermGoals ? (howManyGoals == 2 ? ' and ' : ', ') : '.'} </span>}
                  {howManyShortTermGoals > 0 &&
                    <span>
                  {this.shortTermGoals.map((stg, idx) =>
                    <span key={idx}>
                      <span
                        className="goal short">{stg.description}</span>{idx == howManyShortTermGoals - 1 ? '.' : (idx == howManyShortTermGoals - 2 ? ', and ' : ', ')}
                    </span>
                  )}
                </span>
                  }
            </span>
          </span>
              :
              <span>Hey {UIState.user.firstName}, <a onClick={this.props.handleClickToGoalsPage}>set your current goals</a>.</span>
            }
          </h2>
        }
        
        <div className={'widgetContainer'+(this.props.mini?' mini':'')} style={widgetContainerStyle}>
          {this.props.chartablePosts.map(chartablePost=><ChartStatus key={chartablePost._id} chartablePost={chartablePost} />)}

          {UIState.settings.ENABLE_GOALS &&
            <div className="statusWidget">
              <a onClick={this.props.handleClickToGoalsPage}><i className="fa fa-line-chart"></i>
                {0 == howManyGoals ?
                  <span className="txt">Set some goals!</span>
                  :
                  <span className="txt">{howManyGoals} goal{howManyGoals > 1 ? 's' : ''}</span>
                }
              </a>
            </div>
          }

          {UIState.feedData.solution.prizes.length>0 &&
            <div className="statusWidget">
              <a role={"link"}
                 onClick={this.props.handleClickToRewardsPage}
              >
                <i aria-hidden={true} className={this.props.icon?this.props.icon:(this.props.milestone?'milestone '+this.props.milestone.icon:'milestone')}></i>
                <span className={"visuallyhidden"}>
                  You have {this.props.pointsStatus},
                  click to view the {this.props.solution.prizesPageName ? this.props.solution.prizesPageName : "Prizes"}
                  page.
                </span>
                <span aria-hidden={true} className="txt">{this.props.pointsStatus}</span>
              </a>
            </div>
          }

        </div>        
      </div>      


    );
  }
}

const ChartStatus = (props:{chartablePost:any}) =>
  <div className="statusWidget">
    <a role={"link"} onClick={()=>{ viewChart(props.chartablePost); } }>
      <i aria-hidden={true} className="icon-graph"></i>
      <span className="txt">{props.chartablePost.title}<span className={"visuallyhidden"}>, click for details.</span></span>
    </a>
  </div>
;



